export default "__VITE_ASSET__4TjeULgv__"